import {EListType} from '../typing';
import CameraIcon from '@/images/photo_generate_book/Camera.webp';
import AddIcon from '@/images/photo_generate_book/add.webp';
import FinishIcon from '@/images/photo_generate_book/finiish.webp';

interface IProps {
  handleCreateWorksFolder: () => void;
  handleAddFiles: () => void;
  handleFinish?: () => void;
  closePage?: () => void;
  type?: number; // 1, 2 目录 0 BOOK
  parentType?: number; // 1, 2 目录 0 BOOK
  childType?: number; // 子项的类型，如果items为空则undefined，否则取第一个item的type
}

export function BtnBox({
  handleCreateWorksFolder,
  handleAddFiles,
  handleFinish,
  closePage,
  type,
  parentType,
  childType
}: IProps) {
  console.log('BtnBox==', { parentType, childType, type });
  return (
    <div
      className="fixed bottom-0 left-0 w-full z-10 flex justify-center items-center"
      style={{ height: 86, boxShadow: '0px -2px 4px 0px rgba(0, 0, 0, 0.1)', background: '#fff' }}
    >
      <div className="flex w-full max-w-[600px] px-4 gap-4">
        {type === 1 ? (
          <>
            <button
              onClick={handleAddFiles}
              className="flex-1 flex items-center justify-center h-[48px] rounded-[10px] bg-[#FFA000] text-white text-[18px] font-medium"
            >
              <span className="mr-2 flex items-center">
                <img src={CameraIcon} alt="camera" style={{height: 18}} />
              </span>
              录入绘本
            </button>
            <button
              onClick={parentType == 2 ? closePage : handleFinish}
              className="flex-1 flex items-center justify-center h-[48px] rounded-[10px] bg-[#4ECB71] text-white text-[18px] font-medium"
            >
              <span className="mr-2 flex items-center">
                <img src={FinishIcon} alt="finish" style={{height: 18}} />
              </span>
              
              {parentType == 2 ? '返回上级' : '完成提交'}

            </button>
          </>
        ) : (
          <>
            {(!childType || childType === 0) && (
              <button
                onClick={handleAddFiles}
                className="flex-1 flex items-center justify-center h-[48px] rounded-[10px] bg-[#FFA000] text-white text-[18px] font-medium"
              >
                <span className="mr-2 flex items-center">
                  <img src={CameraIcon} alt="camera" style={{height: 18}} />
                </span>
                录入绘本
              </button>
            )}
            {(!childType || childType === 1) && (
              <button
                onClick={handleCreateWorksFolder}
                className="flex-1 flex items-center justify-center h-[48px] rounded-[10px] bg-[#6372FF] text-white text-[18px] font-medium"
              >
                <span className="mr-2 flex items-center">
                  <img src={AddIcon} alt="add" style={{height: 18}} />
                </span>
                添加目录
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
